import { Card, CardContent, CardHeader, Typography } from "@material-ui/core";
import { Camera } from "@material-ui/icons";
import { Link } from "react-router-dom";
import { pURLs } from "../../utils/parameters";
import { useTranslation } from "react-i18next";

export function CameraPermissionsPrompt() {
  const { t } = useTranslation("global")

  function handleLink() {
    window.open(pURLs.help);
  }

  return (
    <Card className="sig_Home_Camera_Permissions" style={{ borderRadius: '15px' }}>
      <CardHeader
        avatar={<Camera className="sig_Home_ChangeOnDarkMode" />}
        title={
          <Typography variant="h5" component="h2">
            {t("sCamPermissions.title")}
          </Typography>
        }
      />
      <CardContent>
        <Typography variant="body1" component="p" align="justify">
          {t("sCamPermissions.description")}{" "}
          <Link className="sig_Home_Camera_Link" to="/#" onClick={handleLink} key={"permissions"}>
            {t("strButton.link_here")}
          </Link>
          .
        </Typography>
        <br />
        <Typography variant="body1" component="p" align="justify">
          {t("sCamPermissions.advice")}
        </Typography>
      </CardContent>
    </Card>
  );
}
